function toggleFeatCollA() {
  document.getElementById('home-feat-1').style.setProperty("display", "block", "important");
  document.getElementById('home-feat-2').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-3').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-4').style.setProperty("display", "none", "important");
}

function toggleFeatCollB() {
  document.getElementById('home-feat-1').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-2').style.setProperty("display", "block", "important");
  document.getElementById('home-feat-3').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-4').style.setProperty("display", "none", "important");  
}
  
function toggleFeatCollC() {
  document.getElementById('home-feat-1').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-2').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-3').style.setProperty("display", "block", "important");
  document.getElementById('home-feat-4').style.setProperty("display", "none", "important");  
}

function toggleFeatCollD() {
  document.getElementById('home-feat-1').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-2').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-3').style.setProperty("display", "none", "important");
  document.getElementById('home-feat-4').style.setProperty("display", "block", "important");
}
